import * as types from "./mutations.type";

const isSet = action => action === "set";
const makeMutation = prop => (state, value) => {
  state[prop] = value;
};

const mutations = Object.entries(types).reduce((acc, [key, value]) => {
  const [action, prop] = value.split("/");

  if (isSet(action)) {
    acc[value] = makeMutation(prop);
  }

  return acc;

}, {});

export default {
  ...mutations,
  [types.resetMunicipiosFiltereds]: state => {
    state.selecteds = state.municipios;
  },
  [types.resetEstadosFiltereds]: state => {
    state.estadosFiltereds = [];
  },
  [types.addMunicipios]: (state, value) => {
    state.municipios = value;
  },
  [types.addMunicipiosFiltereds]: (state, value) => {
    state.municipiosFiltereds = value;
  },
  [types.setLatest]: (state, value) => {
    state.latestClicked = value;
    localStorage.setItem('latestClicked' , JSON.stringify(value))
  }
};
